import TimeService from "@services/timeService/timeService";

import { Device } from "../types";

export const getDeviceUptime = (device: Device | null) => {
    if (!device?.isOnline) {
        return null;
    }

    const uptimeMs = device.lastState?.datetime?.elapsedMs;

    if (!uptimeMs) {
        return null;
    }

    const deviceCurrentMs = device.lastState?.datetime?.currentMs;
    const zone = device.lastState?.properties?.["persist.sys.timezone"] || "UTC";

    if (!deviceCurrentMs) {
        return null;
    }

    const bootTime = TimeService.getFromMillis(deviceCurrentMs - uptimeMs);
    return TimeService.getHumanReadableTimeDifference(bootTime, { zone });
};

export const getDeviceOnlineSince = (device: Device | null) => {
    if (!device?.isOnline || !device.lastOnlineDate) {
        return null;
    }
    return TimeService.getHumanReadableTimeDifference(device.lastOnlineDate, { zone: "UTC" });
};
